const TargetingConstants = {
  ALL: "ALL",
  ALL_DEFAULT_VALUE: "ALL",
  AND: "AND",
  BUDGET: "budget",
  DEAL: "deal",
  DEAL_GROUP: "deal_group",
  EXCLUDE: "exclude",
  EXPIRED_DEAL: "expired_deal",
  FIXED: "FIXED",
  FLOOR: "FLOOR",
  FORECAST_INNER_WIDTH: 585,
  GROUP_1: "Group 1",
  INCLUDE: "include",
  INCLUDE_COLOR: "#4F7226",
  INVENTORY_SITE_LIST: "siteList",
  INVENTORY_SUPPLY: "supply",
  LOCATION_DMAX: "DMAX",
  LOCATION_REGN: "REGN",
  MARKETPLACE: "MARKETPLACE",
  NEVER_END_DATE_YEAR: 2999,
  OPEN_EXCHANGES_SSP: "OPEN EXCHANGES & SSP",
  OR: "OR",
  PAGE_SIZE: 100,
  PIXEL_ADAPTIVE: "dynamic",
  PIXEL_DATA: "data",
  PIXEL_EVENT: "event",
  PIXEL_SEGMENT: "segment",
  SEARCH_CONTAIN: "contain",
  SEARCH_EXACTLY: "exactly",
  STANDARD: "STANDARD",
  STRATEGY_PLANS: "strategy_plans",
  SUPPLY_OPEN: "supply_sources",
  SUPPLY_PMPE_DEAL_GROUP: "deal_groups",
  SUPPLY_PMPE_DEALS: "deals",
  SUPPLY_SOURCE: "supply_source",
  TARGETING_AUDIENCE: "audience",
  TARGETING_CONTEXTUAL: "contextual",
  TARGETING_LOCATION: "location",
  TARGETING_MYDATA: "myData",
  TARGETING_TECHNOLOGY: "technology",
  TECHNOLOGY_BROWSER: "BSER",
  TECHNOLOGY_BROWSER_LANGUAGE: "BROWSERLANGUAGE",
  TECHNOLOGY_CONNECTION_SPEED: "CSPD",
  TECHNOLOGY_DEVICE_MODEL: "DVMD",
  TECHNOLOGY_DEVICE_TYPE: "DVCE",
  TECHNOLOGY_INVENTORY_TYPE: "INVT",
  TECHNOLOGY_ISP: "ISPX",
  TECHNOLOGY_OS_VERSION: "OSXX",
  TOTAL_BUDGET: "totalBudget",
};

export default TargetingConstants;
